//state with suggestions actions

import axios from 'axios'
// get default data from config file
import configData from '../../config'
// request path
import getSearchPath from './../../scripts/modules/solr-helper'

const state = {
  suggests: [],
  activeMouse: '',
  activeSuggestTmp: '',
  activeSuggestions: false,
  activeAutocompleteDropdown: false
}

const getters = {
  GET_SUGGESTIONS: state => {
    return state.suggests
  },

  GET_ACTIVE_MOUSE: state => {
    return state.activeMouse
  },

  GET_ACTIVE_SUGGEST_TMP: state => {
    return state.activeSuggestTmp
  },

  GET_IS_ACTIVE_SUGGESTIONS: state => {
    return state.activeSuggestions
  },

  GET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN: state => {
    return state.activeAutocompleteDropdown
  }

}

const actions = {
  LOAD_SUGGESTIONS: ({commit}, params) => {

    let solrSearchQuery = configData().solr.paths.API

    axios.get( solrSearchQuery + 'terms?terms.fl='+ params.parameter +'&terms.prefix=' + params.params.key  +'&terms=true&terms.limit=10&wt=json')
      .then(function (response) {
        let list = response.data.terms[params.parameter]

        let filteredList = list.filter(function(el, index) {
          return index % 2 === 0
        })
        commit('SET_SUGGESTIONS', filteredList)

      })
  }
}

const mutations = {
  SET_SUGGESTIONS: (state, data) => {
    state.suggests = data
  },
  SET_ACTIVE_MOUSE: (state, number) => {
    state.activeMouse = number
  },
  SET_ACTIVE_SUGGEST_TMP: (state, value) => {
    state.activeSuggestTmp = value
  },
  SET_IS_ACTIVE_SUGGESTIONS: (state, boolean) => {
    state.activeSuggestions = boolean
  },
  SET_IS_ACTIVE_AUTOCOMPLETE_DROPDOWN: (state, boolean) => {
    state.activeAutocompleteDropdown = boolean
  },
  RESET_SUGGESTIONS: (state) => {
    state.suggests = []
  }
}

export {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/autocomplete.js